import { render, staticRenderFns } from "./Gravatar.vue?vue&type=template&id=0f494c02"
import script from "./Gravatar.vue?vue&type=script&setup=true&lang=js"
export * from "./Gravatar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports